module.exports = __webpack_public_path__ + "static/cpm-ca-logo-v3.3ba61b24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cpm-ca-logo-v3.svg
// module id = 633
// module chunks = 114276838955818